import { useSignupStoreData } from '../store/useSignupStore'
import { SignupFormData } from './useSignupForm'

export const useSignupFormDefaultValues = (): Partial<SignupFormData> => {
  const {
    email,
    firstname,
    lastname,
    userAcceptsTerms,
    hasConsentedForMarketing,
    hasConsentedForThirdPartyCommunication,
    allOptionalConsent,
  } = useSignupStoreData()

  return {
    email: email || '',
    firstname: firstname || '',
    lastname: lastname || '',
    password: '',
    userAcceptsTerms: userAcceptsTerms || false,
    hasConsentedForMarketing: hasConsentedForMarketing || false,
    hasConsentedForThirdPartyCommunication:
      hasConsentedForThirdPartyCommunication || false,
    allOptionalConsent: allOptionalConsent || false,
  }
}
